import React from 'react';
import { BellIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
interface NotificationButtonProps {
  hasNotification?: boolean;
}
export const NotificationButton = ({
  hasNotification = true
}: NotificationButtonProps) => {
  const navigate = useNavigate();
  return <button onClick={() => navigate('/chat/notification-alert')} className="relative flex items-center gap-2 bg-[#1a1a1a] hover:bg-[#2a2a2a] transition-all duration-200 px-4 py-2 rounded-lg border border-[#444444] hover:border-[#4a90e2] group" title="View notification" data-id="element-137">
      <BellIcon size={18} className="text-[#e0e0e0] group-hover:text-[#4a90e2] transition-colors" data-id="element-138" />
      {hasNotification && <>
          <div className="absolute top-1 right-1 w-2.5 h-2.5 bg-[#ff4444] rounded-full" data-id="element-139"></div>
          <div className="absolute top-1 right-1 w-2.5 h-2.5 bg-[#ff4444] rounded-full animate-ping" data-id="element-140"></div>
        </>}
    </button>;
};